import type { InferRouterOutputs } from "@orpc/server";
import type { ApiRouter } from "@repo/api/orpc/router";
import { orpc } from "@shared/lib/orpc";

type Outputs = InferRouterOutputs<ApiRouter>["domains"];
export type DomainsData = Outputs["list"];
export type CustomDomain = DomainsData["domains"][number];

/** While a domain waits, the list refreshes on its own: the worker checks every 5 minutes. */
const PENDING_REFETCH_MS = 30_000;

export const domainsQuery = (organizationId: string) =>
	orpc.domains.list.queryOptions({
		input: { organizationId },
		refetchInterval: (query) =>
			query.state.data?.domains.some((d) => d.status === "PENDING")
				? PENDING_REFETCH_MS
				: false,
	});
